import ordersService, { IOrder } from "src/function/ordersService";

export interface GetUserOrders {
  status: boolean,
  orders: IOrder[]
}

const useFetchUserOrders = () => {

  async function getUserOrders(id: number): Promise<GetUserOrders> {
    const userBalance = await ordersService.getUserOrders(id);

    if (userBalance.status === 'ok') {
      return {
        status: true,
        orders: userBalance.data.orders
      }
    } else {
      return {
        status: false,
        orders: []
      }
    }
  }


  return { getUserOrders }
}

export default useFetchUserOrders